// components/plScenario/table/TotalRow.jsx
import React from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const TotalRow = ({
  label,
  monthlyTotals,
  months,
  quarters,
  viewMode,
  bgColor = 'bg-blue-50',
  textColor = 'text-gray-900',
  bold = true,
  collapsible = false,
  sectionKey = null,
  isCollapsed = false,
  onToggle,
  formatCurrency,
}) => {
  return (
    <tr 
      className={`${bgColor} ${bold ? 'font-bold' : ''} ${collapsible ? 'cursor-pointer hover:bg-opacity-80' : ''}`}
      onClick={collapsible && sectionKey ? onToggle : undefined}
    >
      <td className={`px-6 py-3 ${textColor} border-b-2 border-gray-300 text-xs`}>
        {collapsible && (
          <span className="inline-block mr-2">
            {isCollapsed ? (
              <ChevronRightIcon className="w-3 h-3 inline" />
            ) : (
              <ChevronDownIcon className="w-3 h-3 inline" />
            )}
          </span>
        )}
        {label}
      </td>
      
      {viewMode === 'monthly' ? (
        months.map((month) => (
          <td
            key={month.month_num}
            className={`px-2 py-3 text-center ${textColor} border-b-2 border-gray-300 text-xs`}
          >
            {formatCurrency(monthlyTotals[month.month_num] || 0)}
          </td>
        ))
      ) : (
        quarters.map((quarter) => {
          const quarterTotal = quarter.months.reduce((sum, month) => {
            return sum + (monthlyTotals[month.month_num] || 0);
          }, 0);
          return (
            <td
              key={quarter.quarter}
              className={`px-2 py-3 text-center ${textColor} border-b-2 border-gray-300 text-xs`}
            >
              {formatCurrency(quarterTotal)}
            </td>
          );
        })
      )}
      
      <td className={`px-6 py-3 text-center ${textColor} ${bgColor === 'bg-blue-50' ? 'bg-blue-50' : 'bg-darkblue-500'} border-b-2 border-gray-300 text-xs`}>
        {formatCurrency(
          Object.values(monthlyTotals).reduce((s, v) => s + v, 0)
        )}
      </td>
    </tr>
  );
};

export default TotalRow;